import { render, staticRenderFns } from "./OrderPrice.vue?vue&type=template&id=356892b8&scoped=true&"
import script from "./OrderPrice.vue?vue&type=script&lang=ts&"
export * from "./OrderPrice.vue?vue&type=script&lang=ts&"
import style0 from "./OrderPrice.vue?vue&type=style&index=0&id=356892b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356892b8",
  null
  
)

export default component.exports